import { getEnvironmentConfig, getCurrentEnvironment } from './environments';

// Получаем конфигурацию для текущего окружения
const envConfig = getEnvironmentConfig();

// Автоматическое определение API URL на основе текущего хоста
// Если приложение загружено не с localhost, используем тот же хост для API
const getApiBaseURL = (): string => {
  // Если указана переменная окружения, используем её (высший приоритет)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Если мы в браузере, определяем API URL на основе текущего хоста
  if (typeof window !== 'undefined') {
    const currentHost = window.location.hostname.toLowerCase();
    const currentProtocol = window.location.protocol;
    
    // ПРИОРИТЕТ 1: Если загружены с домена ryaskov.pro или www.ryaskov.pro
    // Используем api.ryaskov.pro для API
    if (currentHost === 'ryaskov.pro' || currentHost === 'www.ryaskov.pro') {
      console.log('🌐 Обнаружен домен ryaskov.pro, используем https://api.ryaskov.pro/api/v1');
      return `https://api.ryaskov.pro/api/v1`;
    }
    
    // ПРИОРИТЕТ 2: Если загружены через туннель (trycloudflare.com, loca.lt, ngrok.io и т.д.)
    const isTunnel = currentHost.includes('trycloudflare.com') || 
                     currentHost.includes('loca.lt') || 
                     currentHost.includes('ngrok.io') ||
                     currentHost.includes('ngrok-free.app');
    
    if (isTunnel) {
      // Если бэкенд проксируется через тот же туннель, используем тот же домен
      // В противном случае нужна переменная окружения REACT_APP_API_URL
      const protocol = currentProtocol === 'https:' ? 'https' : 'http';
      const tunnelApiUrl = `${protocol}://${currentHost}/api/v1`;
      
      console.warn('⚠️ Обнаружен туннель:', currentHost);
      console.warn('💡 Пытаемся использовать тот же домен для API:', tunnelApiUrl);
      console.warn('💡 Если не работает, создайте отдельный туннель для бэкенда и установите REACT_APP_API_URL');
      
      // Пробуем использовать тот же домен туннеля для API
      // Это работает, если бэкенд проксируется через тот же туннель
      return tunnelApiUrl;
    }
    
    // ПРИОРИТЕТ 3: Если загружены с IP адреса (локальная сеть через VPN или сервер)
    // Проверяем, что это IP адрес (содержит точку, но не доменное имя)
    const isIPAddress = /^\d{1,3}(\.\d{1,3}){3}$/.test(currentHost);
    if (currentHost !== 'localhost' && currentHost !== '127.0.0.1' && isIPAddress) {
      // Если это IP сервера с nginx (95.214.8.95), используем тот же IP без порта (через nginx)
      // Nginx проксирует запросы на бэкенд
      const protocol = currentProtocol === 'https:' ? 'https' : 'http';
      // Используем тот же IP, но без порта - nginx проксирует на порту 80
      return `${protocol}://${currentHost}/api/v1`;
    }
    
    // ПРИОРИТЕТ 4: localhost - используем localhost
    if (currentHost === 'localhost' || currentHost === '127.0.0.1') {
      return 'http://localhost:5000/api/v1';
    }
  }
  
  // По умолчанию используем конфигурацию окружения
  return envConfig.api.baseURL;
};

// Отладочная информация
console.log('🔧 Конфигурация загружается:');
console.log('REACT_APP_ENVIRONMENT:', process.env.REACT_APP_ENVIRONMENT);
console.log('REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
console.log('Текущее окружение:', getCurrentEnvironment());
console.log('envConfig.api.baseURL:', envConfig.api.baseURL);
if (typeof window !== 'undefined') {
  const currentHost = window.location.hostname.toLowerCase();
  const determinedUrl = getApiBaseURL();
  console.log('=== ОПРЕДЕЛЕНИЕ API URL ===');
  console.log('Текущий хост:', currentHost);
  console.log('Протокол:', window.location.protocol);
  console.log('Полный URL страницы:', window.location.href);
  console.log('Определенный API URL:', determinedUrl);
  console.log('REACT_APP_API_URL (env):', process.env.REACT_APP_API_URL || 'не установлена');
  console.log('========================');
}

export const config = {
  // API настройки (из конфигурации окружения)
  api: {
    baseURL: getApiBaseURL(),
    timeout: envConfig.api.timeout,
  },
  
  // Настройки аутентификации
  auth: {
    tokenKey: 'authToken',
    refreshTokenKey: 'refreshToken',
    userKey: 'user',
  },
  
  // Настройки приложения (из конфигурации окружения)
  app: {
    name: process.env.REACT_APP_APP_NAME || envConfig.app.name,
    version: process.env.REACT_APP_VERSION || envConfig.app.version,
    debug: envConfig.app.debug,
    defaultRoute: '/dashboard',
    loginRoute: '/login',
  },
  
  // Настройки UI
  ui: {
    loadingDelay: 300, // Задержка перед показом индикатора загрузки
    animationDuration: 300, // Длительность анимаций
  },
  
  // Настройки функций (из конфигурации окружения)
  features: {
    enableLogging: envConfig.features.enableLogging,
    enableAnalytics: envConfig.features.enableAnalytics,
    enableErrorReporting: envConfig.features.enableErrorReporting,
  },
};

export default config;
